import { render } from "./BasisProductList.vue?vue&type=template&id=6642696a&scoped=true&ts=true"
import script from "./BasisProductList.vue?vue&type=script&lang=ts"
export * from "./BasisProductList.vue?vue&type=script&lang=ts"

import "./BasisProductList.vue?vue&type=style&index=0&id=6642696a&scoped=true&lang=scss"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6642696a"]])

export default __exports__